<!--
 * @Author: 71
 * @Date: 2025-09-08 14:31:21
 * @LastEditTime: 2025-09-19 15:10:48
 * @LastEditors: 71
 * @Description: 拷贝来自 src\views\school\schoolActivity\modules\SchoolActivityModal.vue
 * @FilePath: \aigoes-school-web\src\views\school\schoolActivityCalendar\modules\SchoolActivityCalendarModal.vue
 * 苍天eye有，bug木有~~
-->
<template>
  <j-modal
    :title="title"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">

        <a-row :gutter="24">
          <!-- 左侧列 -->
          <a-col :span="9">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="title" label="活动名称" required>
                <a-input :style="{width: '206px'}" v-model="model.title" placeholder="请输入活动名称"></a-input>
              </a-form-model-item>

              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="acDateRange" label="活动时间" required>
                <a-range-picker :style="{width: '206px'}" @change="onRangeChange" :value="model.acDateRange" />
              </a-form-model-item>

              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="gradeId" label="活动范围" class="ant-form-item-required-71">
                <j-dict-select-tag :style="{width: '206px'}" 
                v-model="model.gradeId" 
                dictCode="school_grade,grade_name,id,delete_flag=0" 
                :extra-options="[{ value: '', text: '全校' }]"
                @clear="onGradeClear" 
                placeholder = '请选择年级'/>
              </a-form-model-item>

              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="picUrl" label="活动封面" required>
                <j-image-upload text="上传活动图片" v-model="model.picUrl" :isMultiple="true"></j-image-upload>
              </a-form-model-item>

              <!-- <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="videoUrl" label="视频链接">
                <j-upload  v-model="model.videoUrl" placeholder="请输入样例文本内容"></j-upload>
              </a-form-model-item> -->

              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="visible" label="家长可见" required>
                <j-dict-select-tag :style="{width: '206px'}" v-model="model.visible" dictCode="visible_status" />
              </a-form-model-item>
          </a-col>

          <!-- 右侧列 (WangEditor) -->
          <a-col :span="15">
            <a-form-model-item
              label=""
              prop="content"
            >
              <WangEditor
                v-model="model.content"
                :editorStyle="{ minHeight: '200px' }"
                style="margin: 2px; border: 1px solid #d9d9d9; border-radius: 4px; overflow: hidden"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
  import { httpAction } from '@/api/manage'
  import moment from "moment"
  import JDictSelectTag from '@/components/dict/JDictSelectTag'
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import JUpload from '@/components/jeecg/JUpload'
  import WangEditor from '@/components/WangEditor'
  export default {
    name: "SchoolActivityCalendarModal",
    components:{
      JImageUpload,
      JDictSelectTag,
      JUpload,
      WangEditor
  },
    data () {
      return {
        title:"新增校园日历",
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        confirmLoading: false,
        validatorRules:{
          title: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
          acDateRange: [{ required: true, message: '请选择活动时间', trigger: 'change' }],
          gradeId: [{
            required: false, // 不使用内置的 required 验证
            validator: (rule, value, callback) => {
              // 检查是否为必填但未选择任何值的情况
              // 注意：当选择"全校"时，value 为空字符串 ''，这是有效的
              // 当未选择任何内容时，value 为 undefined 或 null
              if (value === undefined || value === null) {
                callback(new Error('请选择活动范围'));
              // 如果值为空字符串 ''，说明选择了"全校"，这是允许的
              } else if (value === '') {
                callback();
              // 其他情况（选择了具体年级）也是允许的
              } else {
                callback();
              }
            }, 
            trigger: 'change' 
          }],
          picUrl: [{ required: true, message: '请上传活动封面', trigger: 'change' }],
          visible: [{ required: true, message: '请选择家长可见状态', trigger: 'change' }]
        },
        url: {
          add: "/aigoes/schoolActivityCalendar/add",
          edit: "/aigoes/schoolActivityCalendar/edit",
        },
      }
    },
    created () {
    },
    methods: {
      add () {
        //初始化默认值
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        // 初始化日期范围 - 关键代码
        if (record.beginDate && record.endDate) {
          try {
            // 确保日期格式正确并转换为 moment 对象
            const beginMoment = moment(record.beginDate);
            const endMoment = moment(record.endDate);
            
            if (beginMoment.isValid() && endMoment.isValid()) {
              this.$set(this.model, 'acDateRange', [beginMoment, endMoment]);
            }
          } catch (error) {
            console.warn('日期转换失败:', error);
          }
        }
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.$refs.form.clearValidate();
      },
      onGradeClear() {
        this.model.gradeId = null;
        this.model.gradeId_dictText = null;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
         this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }else{
             return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
      //修改时间范围
      onRangeChange(dates, dateString) {
        this.model.rangeType = 'range'
        this.$set(this.model, 'acDateRange', dates);

        this.model.beginDate = dateString[0]
        this.model.endDate = dateString[1]
      },
    }
  }
</script>

<style lang="less" scoped>
  ::v-deep .ant-form-item-required-71 .ant-form-item-label > label::before {
    display: inline-block;
    margin-right: 4px;
     color: #f5222d;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
    content: "*";
  }
</style>